// getDisplayLocation — derive the human-readable search-location label.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the `displayLocation`
// derivation inside the `SearchHeader` sub-component) as part of the
// behavior-preserving refactor (issue #240). The conditional is copied exactly:
// when searching by hotel with a selected hotel, prefer the hotel address then
// its name; otherwise prefer the location address, then its airport code, then
// the literal fallback 'Search location'.
//
// Totality mirrors the source EXACTLY:
//   The `searchLocation === 'hotel' && selectedHotel` guard short-circuits
//   before `selectedHotel.address`/`.name` are read, and the location branch
//   uses optional chaining (`location?.address`, `location?.airportCode`)
//   exactly as the source did, so null/undefined `location`/`selectedHotel`
//   fall through to 'Search location' without throwing. No extra guard added.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Derive the location label shown in the search header.
 *
 * @param {string} searchLocation - The selected search location type ('hotel' | 'airport').
 * @param {Object} selectedHotel - The selected hotel ({ address?, name? }) or null/undefined.
 * @param {Object} location - The trip location ({ address?, airportCode? }) or null/undefined.
 * @returns {string} The display label for the current search location.
 */
function getDisplayLocation(searchLocation, selectedHotel, location) {
  return searchLocation === 'hotel' && selectedHotel
    ? selectedHotel.address || selectedHotel.name
    : (location?.address || location?.airportCode || 'Search location');
}

export { getDisplayLocation };
export default getDisplayLocation;
